// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindParentalSetting, TagKindParentalSetting } from "../schema";
import { serialize_KindParentalSetting_internal, deserialize_KindParentalSetting_internal } from "./KindParentalSetting";

export function serialize_TagKindParentalSetting_internal(value: TagKindParentalSetting): unknown {
  return ((value: { discriminator: KindParentalSetting; id: bigint; kind: KindParentalSetting }): unknown => {
    return {
      discriminator: ((value: KindParentalSetting): unknown => {
        return serialize_KindParentalSetting_internal(value);
      })(value["discriminator"]),
      id: ((value: bigint): unknown => {
        return value;
      })(value["id"]),
      kind: ((value: KindParentalSetting): unknown => {
        return serialize_KindParentalSetting_internal(value);
      })(value["kind"]),
    };
  })(value);
}
export function serialize_TagKindParentalSetting(obj: TagKindParentalSetting): string {
  return renderJsonWithNumbersAsBigint(serialize_TagKindParentalSetting_internal(obj));
}
export function deserialize_TagKindParentalSetting_internal(value: unknown): ParserResult<TagKindParentalSetting> {
  return ((
    value: unknown,
  ): ParserResult<{
    discriminator: KindParentalSetting;
    id: bigint;
    kind: KindParentalSetting;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/TagKindParentalSetting]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/TagKindParentalSetting]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "discriminator")) {
      return { success: false, reason: `[#/components/schemas/TagKindParentalSetting/discriminator]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'discriminator'.` };
    }
    const parsed_discriminator = ((): ParserResult<KindParentalSetting> => {
      return ((value: unknown): ParserResult<KindParentalSetting> => {
        return deserialize_KindParentalSetting_internal(value);
      })(value["discriminator"]);
    })();
    if (!parsed_discriminator.success) {
      return { success: false, reason: parsed_discriminator.reason };
    }
    if (!hasProp(value, "id")) {
      return { success: false, reason: `[#/components/schemas/TagKindParentalSetting/id]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'id'.` };
    }
    const parsed_id = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/TagKindParentalSetting/id]: '${value}' expected to be of type bigint or number.` };
      })(value["id"]);
    })();
    if (!parsed_id.success) {
      return { success: false, reason: parsed_id.reason };
    }
    if (!hasProp(value, "kind")) {
      return { success: false, reason: `[#/components/schemas/TagKindParentalSetting/kind]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
    }
    const parsed_kind = ((): ParserResult<KindParentalSetting> => {
      return ((value: unknown): ParserResult<KindParentalSetting> => {
        return deserialize_KindParentalSetting_internal(value);
      })(value["kind"]);
    })();
    if (!parsed_kind.success) {
      return { success: false, reason: parsed_kind.reason };
    }
    return { success: true, value: { discriminator: parsed_discriminator.value, id: parsed_id.value, kind: parsed_kind.value } };
  })(value);
}
export function deserialize_TagKindParentalSetting(str: string): ParserResult<TagKindParentalSetting> {
  return deserialize_TagKindParentalSetting_internal(parseJsonWithNumbersAsBigint(str));
}
